import React from 'react';
import Select from "react-select";
import withReactContent from 'sweetalert2-react-content';
import swal from 'sweetalert2';
import { enables, requireds } from '../constants';
import { ThemeActions } from '../ThemeActions';
import { Tooltip } from '../../UI/Tooltip/Tooltip';
import Icon from '../../UI/Icon/Icon';

const MySwal = withReactContent(swal);

export const ThemeFieldSettings = ({
  fieldTheme,
  handleChangeCompanyData,
  handleChangeFieldSetting,
  removeField,
}) => {
  const editFieldName = async (field) => {
    const { value: name } = await MySwal.fire({
      title: "Enter new field name",
      input: "text",
      inputValue: field.name,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: "Confirm",
    });

    if (name) {
      handleChangeFieldSetting(field.type, 'name', name, field.id)
    }
  }

  const showRemoveFieldModal = (field) => {
    MySwal.fire({
      title: "Are you sure you want to remove this field?",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Remove",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        removeField(field);
      }
    });
  };

  return (
    <article className='theme-settings'>
      <h3 className='theme-settings__subtitle'>
        Field settings
        <Tooltip
          className="add-event__tooltip"
          description="These settings will affect fields on 'Sell', 'Slug' and 'Offer' pages."
        >
          <Icon name="info" />
        </Tooltip>
      </h3>
      <div className='theme-settings__fields-container'>
        <div className='theme-settings__field-settings'>
          <div className="theme-settings__field-name">Email</div>
          <Select
            options={requireds}
            name="isRequired"
            value={requireds.find(({ value }) => value)}
            classNamePrefix="custom-select"
            className="partizan-open-selling__select"
            isDisabled
          />
          <Select
            options={enables}
            name="isEnabled"
            value={enables.find(({ value }) => value)}
            classNamePrefix="custom-select"
            className="partizan-open-selling__select"
            isDisabled
          />
        </div>

        {fieldTheme.map((ft) => {
          if (ft.type === 0) return null;

          if (ft.type === 9 || ft.type === 10) {
            return (
              <div className='theme-settings__field-settings'>
                <div className="theme-settings__field-name">
                  {ft.name}

                  <Tooltip
                    className="add-event__tooltip"
                    relevantX={-100}
                    description="Company Name and VAT Number are linked. Updating one field will affect the other."
                  >
                    <Icon name="info" />
                  </Tooltip>
                </div>

                <Select
                  options={requireds}
                  name="isRequired"
                  value={requireds.find(({ value }) => ft.isRequired === value)}
                  onChange={(value) => handleChangeCompanyData('isRequired', value.value, ft.id)}
                  classNamePrefix="custom-select"
                  className="partizan-open-selling__select"
                />

                <Select
                  options={enables}
                  name="isEnabled"
                  value={enables.find(({ value }) => ft.isEnabled === value)}
                  onChange={(value) => handleChangeCompanyData('isEnabled', value.value, ft.id)}
                  classNamePrefix="custom-select"
                  className="partizan-open-selling__select"
                />
              </div>
            )
          }

          return (
            <div className='theme-settings__field-settings'>
              <div className="theme-settings__field-name">
                {ft.name}
              </div>
              <Select
                options={requireds}
                name="isRequired"
                value={requireds.find(({ value }) => ft.isRequired === value)}
                onChange={(value) => handleChangeFieldSetting(ft.type, 'isRequired', value.value, ft.id)}
                classNamePrefix="custom-select"
                className="partizan-open-selling__select"
              />
              <Select
                options={enables}
                name="isRequired"
                value={enables.find(({ value }) => ft.isEnabled === value)}
                onChange={(value) => handleChangeFieldSetting(ft.type, 'isEnabled', value.value, ft.id)}
                classNamePrefix="custom-select"
                className="partizan-open-selling__select"
              />
            </div>
          )
        })}

        {fieldTheme.map((ft) => {
          if (ft.type === 0) {
            return (
              <div className='theme-settings__field-settings theme-settings__field-settings--col-4'>
                <div className="theme-settings__field-name">{ft.name}</div>
                <Select
                  options={requireds}
                  name="isRequired"
                  value={requireds.find(({ value }) => ft.isRequired === value)}
                  onChange={(value) => handleChangeFieldSetting(ft.type, 'isRequired', value.value, ft.id)}
                  classNamePrefix="custom-select"
                  className="partizan-open-selling__select"
                />
                <Select
                  options={enables}
                  name="isRequired"
                  value={enables.find(({ value }) => ft.isEnabled === value)}
                  onChange={(value) => handleChangeFieldSetting(ft.type, 'isEnabled', value.value, ft.id)}
                  classNamePrefix="custom-select"
                  className="partizan-open-selling__select"
                />

                <ThemeActions
                  editFieldName={() => editFieldName(ft)}
                  showRemoveFieldModal={() => showRemoveFieldModal(ft)}
                />
              </div>
            )
          } else {
            return null;
          }
        })}
      </div>
    </article>
  )
}
